import React, { useState } from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { Navigate, useParams } from 'react-router';

import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';

import { RootState } from '../../../../app/rootReducer';
import { IconLink } from '../../../../common/components/IconLink';
import { DecisionType } from '../../../../common/constants/decision';
import { Resource } from '../../../../common/constants/resource';
import ElementLocators from '../../../../common/ElementLocators';
import { tasksResolved } from '../../../../common/helpers';
import { ApproveDrawer } from '../../../detail/drawer/approve/ApproveDrawer';
import { InvalidDrawer } from '../../../detail/drawer/InvalidDrawer';
import { ITask } from '../../../tasks/interfaces/ITask';
import { getAllTasks } from '../../../tasks/slice/taskListSlice';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

const ApproveApplication = ({
  hasFinalDecision,
  hasPIADecision,
  isRUW,
}: {
  hasFinalDecision: boolean;
  hasPIADecision: boolean;
  isRUW: boolean;
}) => {
  const tasks: ITask[] = useSelector(state => getAllTasks(state.taskList));
  const allDecisions = useSelector(state => state.decision.decisions);
  const engineMaxCoverage = allDecisions?.find(
    d => !d.ignored && d.decisionType === DecisionType.ENGINE,
  )?.coverage;

  const copy = 'Approve application';

  // For controlling the ApproveDrawer component
  const [isOpen, setIsOpen] = useState(false);
  const isValid = tasksResolved(tasks);

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      {!isValid && (
        <InvalidDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          labelCopy={Resource.APPROVE_APPLICATION_HEADER}
        />
      )}
      {isValid && (
        <ApproveDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          applicationId={id}
          hasFinalDecision={hasFinalDecision}
          hasPIADecision={hasPIADecision}
          isRUW={isRUW}
          engineMaxCoverage={engineMaxCoverage}
        />
      )}
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faCheck}
        copy={copy}
        locator={ElementLocators.APPROVE_DECISION_LINK}
      />
    </>
  );
};

export default ApproveApplication;
